import React from "react";
import { formatDate } from "../model/suiviLivraisonFormat";
import { totalUnites } from "../model/suiviLivraisonRules";
import { TD, TH, commandeBlockStyle, commandeSummaryStyle, deliveryInfoStyle, photoButtonStyle } from "../styles/suiviLivraisonStyles";
import { DestinationBadge, EmptyState } from "./SuiviBadges";

// Détail d'une livraison effectuée : caisses, commentaire de la pharmacie, bon signé et lignes livrées.

export function LivraisonDetail({ livraison, onViewPhoto }) {
    const medicaments = livraison.medicaments || [];
    const unites = totalUnites(medicaments);
    return (
        <div style={commandeBlockStyle}>
            <div style={commandeSummaryStyle}>
                <span>
                    <strong style={{ color: "#0f172a" }}>{livraison.ehpadNom || livraison.ehpadCode || "EHPAD non renseigné"}</strong>
                    <span style={{ color: "#64748b", marginLeft: "8px", fontSize: "12px" }}>
                        {formatDate(livraison.dateLivraison)}
                    </span>
                </span>
                <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
                    <span style={{ color: "#64748b", fontSize: "12px" }}>
                        {medicaments.length} ligne{medicaments.length > 1 ? "s" : ""} · {unites} unité{unites > 1 ? "s" : ""}
                    </span>
                    {livraison.signedBonAvailable && <PhotoButton livraison={livraison} onViewPhoto={onViewPhoto} />}
                </span>
            </div>
            {(livraison.commentaireLivreur || livraison.nombreCaisses) && <LivraisonInfos livraison={livraison} />}
            <div style={{ padding: "0 12px 12px", overflowX: "auto" }}>
                {medicaments.length === 0
                    ? <EmptyState>Aucun produit dans cette livraison.</EmptyState>
                    : <LivraisonMedicamentsTable medicaments={medicaments} />}
            </div>
        </div>
    );
}

function PhotoButton({ livraison, onViewPhoto }) {
    return (
        <button
            type="button"
            onClick={event => {
                event.preventDefault();
                event.stopPropagation();
                onViewPhoto({
                    bonLivraisonHistoriqueId: livraison.id,
                    ehpadNom: livraison.ehpadNom,
                    ehpadCode: livraison.ehpadCode,
                    signedBonPhotoCount: livraison.signedBonPhotoCount,
                });
            }}
            style={photoButtonStyle}
        >
            Voir la photo
        </button>
    );
}

function LivraisonInfos({ livraison }) {
    return (
        <div style={{ display: "grid", gap: "8px", padding: "12px 12px 0" }}>
            {livraison.nombreCaisses && (
                <div style={deliveryInfoStyle}>
                    <strong>Nombre de caisses</strong>
                    <span>{livraison.nombreCaisses}</span>
                </div>
            )}
            {livraison.commentaireLivreur && (
                <div style={deliveryInfoStyle}>
                    <strong>Commentaire de la pharmacie</strong>
                    <span>{livraison.commentaireLivreur}</span>
                </div>
            )}
        </div>
    );
}

function LivraisonMedicamentsTable({ medicaments }) {
    return (
        <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed", background: "white", marginTop: "12px" }}>
            <thead>
                <tr>
                    <th style={{ ...TH, width: "24%" }}>Patient</th>
                    <th style={{ ...TH, width: "28%" }}>Produit</th>
                    <th style={{ ...TH, width: "12%" }}>Quantité</th>
                    <th style={{ ...TH, width: "16%" }}>Flux</th>
                    <th style={TH}>Classification</th>
                </tr>
            </thead>
            <tbody>
                {medicaments.map(med => (
                    <tr key={med.id}>
                        <td style={{ ...TD, whiteSpace: "normal" }}>{[med.patientPrenom, med.patientNom].filter(Boolean).join(" ") || "—"}</td>
                        <td style={{ ...TD, whiteSpace: "normal", wordBreak: "break-word" }}>
                            <div style={{ color: "#1e293b", fontWeight: 650 }}>{med.nom}</div>
                            <div style={{ color: "#94a3b8", fontSize: "11px" }}>{med.dosage || "—"}</div>
                        </td>
                        <td style={TD}>{med.quantite ?? "—"}</td>
                        <td style={TD}><DestinationBadge value={med.destination} /></td>
                        <td style={{ ...TD, whiteSpace: "normal" }}>{med.classificationMedicament || "—"}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
